import SearchPresenter from "@adapters/features/Search/Presenters/Search";
export default (useCases, actions) => {
    return {
        search: new SearchPresenter(useCases.search, actions.search),
    };
};
